import {UPDATE_HISTORY} from './actions';

export function history(state: HistoryState, {type, payload}: Action): HistoryState {
  switch (type) {
    case UPDATE_HISTORY:
      return [...(payload as HistoryState)];

    default:
      return state;
  }
}
